import { useEffect, useState } from "react";
import { Card, Avatar, Divider, Empty, Button, message } from "antd";
import { PlusOutlined, UserOutlined } from "@ant-design/icons";

import BlueButton from "../../components/shared/BlueButton";
import SearchAndCreateEmployeeModal from "../../components/employee/SearchAndCreateEmployeeModal";
import RemoveItemModal from "../shared/RemoveModal";

import { getFileUrl } from "../../api/file";
import { createUser } from "../../api/user";
import { UserRole } from "../../lib/constants";

export default function ProjectEmployees({ project, afterClose, user }) {
    const [isEmployeeModalOpen, setIsEmployeeModelOpen] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);

    const onEmployeeSubmit = async (values) => {
        createUser(values).then(() => {
            setIsEmployeeModelOpen(false);
            message.success("Employee created successfully");
        });
    };

    useEffect(() => {
        if (project) {
            setIsDisabled(false)
        }
    }, [project])


    return (
        <Card
            title={<p className="font-medium">Employees on this Project</p>}
            extra={
                user?.role !== UserRole.AccountManager && (
                    <BlueButton
                        type="default"
                        className="flex items-center rounded-none"
                        onClick={() => setIsEmployeeModelOpen(true)}
                        disabled={isDisabled}
                    >
                        <PlusOutlined /> Add Employee to Project
                    </BlueButton>
                )
            }
            className="w-full rounded-none"
        >
            {
                isDisabled ? <EmptyState /> :
                    project.projectUsers &&
                        project.projectUsers.length > 0 &&
                        project.projectUsers.some((projectUser) => projectUser.isActive) ? (
                        project.projectUsers.map((projectUser, index) => {
                            if (projectUser.isActive) {
                                return (
                                    <div className="flex flex-col justify-start p-4" key={index} >
                                        <div
                                            className="w-full flex items-center justify-between pb-2" >
                                            <div className="flex space-x-4 items-center">
                                                <Avatar
                                                    icon={<UserOutlined />}
                                                    src={projectUser.user.avatar ? getFileUrl(projectUser.user.avatar) : null}
                                                />
                                                <div className="flex flex-col justify-start">
                                                    <p className="">
                                                        {projectUser.user.firstName +
                                                            " " +
                                                            projectUser.user.lastName}
                                                    </p>
                                                    <p className="text-sm text-gray-500">
                                                        {projectUser.user.role}
                                                    </p>
                                                </div>
                                            </div>
                                            {user?.role !== UserRole.AccountManager && (
                                                <Button
                                                    type="link"
                                                    onClick={() =>
                                                        RemoveItemModal({
                                                            type: "employee",
                                                            id: projectUser.id,
                                                            refresh: () => afterClose(),
                                                        })
                                                    }
                                                >
                                                    Remove
                                                </Button>
                                            )}
                                        </div>
                                        <Divider className="p-0 m-0" />
                                    </div>
                                );
                            } else return null;
                        })
                    ) : (
                        <EmptyState />
                    )}
            {
                !isDisabled && user?.role !== UserRole.AccountManager &&
                <SearchAndCreateEmployeeModal
                    isModalOpen={isEmployeeModalOpen}
                    handleOk={onEmployeeSubmit}
                    handleCancel={() => setIsEmployeeModelOpen(false)}
                    project={project}
                    afterClose={afterClose}
                />}
        </Card>
    );
}

const EmptyState = () => {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="my-8" />
}
